import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
export default class extends Controller {
  static values = {
    voteId: String,
    languageFilters: Array
  }

  declare readonly voteIdValue: string
  declare readonly languageFiltersValue: string[]
  private previousUrl: string | null = null

  toggleQuestionContainer(event: Event): void {
    const target = event.currentTarget as HTMLElement
    const questionId = target.dataset.questionId
    if (!questionId) return

    const questionContainer = document.querySelector(`#question-${questionId}-container`) as HTMLElement
    const toggleIcon = target.querySelector('.toggle-icon') as HTMLElement
    if (!questionContainer || !toggleIcon) return

    if (questionContainer.classList.contains('hidden')) {
      questionContainer.classList.remove('hidden')
      toggleIcon.innerHTML = '<i class="fas fa-chevron-up"></i>'

      this.previousUrl = window.location.href

      const url = `/votes/translations/${this.voteIdValue}/questions/${questionId}/edit?language_filters=${this.languageFiltersValue.join(',')}`

      Turbo.visit(url, {
        frame: `question-${questionId}-container`,
        action: "replace"
      })

      window.history.pushState({}, '', this.previousUrl)
    } else {
      questionContainer.classList.add('hidden')
      toggleIcon.innerHTML = '<i class="fas fa-chevron-down"></i>'
    }
  }
}
